<div id="lnr-user-main-header">
  <div id="lnr-user-header-icon-area">
    <mat-icon id="lnr-icon-menu" (click)="clickMenu()">menu</mat-icon>
  </div>
  <div>
    <ng-content></ng-content>
  </div>
  <div id="lnr-user-header-photo-area">
    <mat-icon *ngIf="!imgSource" id="lnr-user-header-photo-area-user" [matMenuTriggerFor]="userMenu.menu">account_circle</mat-icon>
    <img *ngIf="imgSource" src="{{imgSource}}" alt="{{alt}}">
    <mat-icon id="lnr-user-header-photo-area-more" [matMenuTriggerFor]="userMenu.menu">expand_more</mat-icon>
  </div>
</div>

<app-profile-menu #userMenu [profileMenuItems]="profileMenuItems"></app-profile-menu>
